// @ts-strict-ignore
export function getLoanRate(rates = [], amount, term) {
  return rates.find((r) => {
    const termFound = term >= r.min_term && term <= r.max_term
    const amountFound = amount >= r.min_amount && amount <= r.max_amount
    return termFound && amountFound
  })
}

const roundTo2DP = (value) => Math.round(value * 100) / 100

export function effectiveRate(apr) {
  return Math.pow(apr * 0.01 + 1, 1.0 / 12.0) - 1
}

export function monthlyPayment(amount, term, effectiveRate) {
  return roundTo2DP((amount * effectiveRate) / (1 - Math.pow(1 + effectiveRate, -term)))
}

export function toMonths(term) {
  return term * 12
}
